import api from "./api";

const getColumnConfig = (implementor, forceSync = false) => {
  return api
    .get("/utility/columnconfig/" + implementor, {
      params: forceSync ? { forceSync: true } : {},
    })
    .then((response) => {
      return response.data;
    });
};

const updateColumnDescription = (data) => {
  return api
    .patch("/utility/columnconfig", {
      ...data,
    })
    .then((response) => {
      return response.data;
    });
};

const UtilityFieldConfigService = {
  getColumnConfig,
  updateColumnDescription,
};

export default UtilityFieldConfigService;
